export const DMAT_SET_TOUR = "DMAT_SET_TOUR";
export const DMAT_SET_OFFLINE = "DMAT_SET_OFFLINE";
